import styled, { css } from "styled-components";

/**
 * Estilos do BancoSelect (Bloco BSEL.4).
 *
 * Mesma estética do design system (SlideOverPanel/RailFlyout) — bordas
 * arredondadas suaves, transição em hover, foco accent, dark mode via
 * tokens do tema.
 */

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  min-width: 0;
`;

export const Trigger = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 7px 10px;
  min-height: 36px;
  background: ${({ theme }) => theme.surfaceAlt};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 8px;
  color: ${({ theme, $vazio }) =>
    $vazio ? theme.textSecondary : theme.textPrimary};
  cursor: pointer;
  font: inherit;
  font-size: 14px;
  text-align: left;
  outline: none;

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.accent};
  }

  &:focus-visible,
  &[aria-expanded="true"] {
    border-color: ${({ theme }) => theme.accent};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.accent}22;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export const TriggerLabel = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TriggerCodigo = styled.strong`
  font-variant-numeric: tabular-nums;
  color: ${({ theme }) => theme.textSecondary};
  font-weight: 600;
  font-size: 12px;
`;

export const TriggerNome = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TriggerActions = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: ${({ theme }) => theme.textSecondary};
  flex-shrink: 0;
`;

export const IconButton = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 4px;
  color: ${({ theme }) => theme.textSecondary};

  &:hover {
    background: ${({ theme }) => theme.border};
    color: ${({ theme }) => theme.textPrimary};
  }
`;

/**
 * Dropdown via Portal — position fixed escapado de qualquer overflow:hidden
 * de ancestrais (padrao do RailFlyout em components/Sidebar/styles.jsx).
 * Posição calculada no JSX via getBoundingClientRect.
 */
export const DropdownPortal = styled.div`
  position: fixed;
  z-index: 1500;
  background: ${({ theme }) => theme.surface};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 10px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  max-height: 460px;
  overflow: hidden;
  animation: bsel-fade-in 0.12s ease-out;

  @keyframes bsel-fade-in {
    from { opacity: 0; transform: translateY(-4px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-bottom: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surfaceAlt};
`;

export const SearchInput = styled.input`
  flex: 1 1 auto;
  min-width: 0;
  background: transparent;
  border: 0;
  outline: none;
  color: ${({ theme }) => theme.textPrimary};
  font: inherit;
  font-size: 14px;

  &::placeholder {
    color: ${({ theme }) => theme.textSecondary};
  }
`;

export const SearchIcon = styled.span`
  color: ${({ theme }) => theme.textSecondary};
  display: inline-flex;
  flex-shrink: 0;
`;

export const ListaScroll = styled.div`
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 6px 0;
`;

export const SecaoTitulo = styled.div`
  padding: 8px 12px 4px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${({ theme }) => theme.textSecondary};
`;

export const ItemBotao = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 12px;
  background: transparent;
  border: 0;
  cursor: pointer;
  text-align: left;
  font: inherit;
  font-size: 13px;
  color: ${({ theme }) => theme.textPrimary};
  outline: none;

  ${({ $active, theme }) =>
    $active &&
    css`
      background: ${theme.surfaceAlt};
    `}

  &:hover,
  &:focus-visible {
    background: ${({ theme }) => theme.surfaceAlt};
  }
`;

export const ItemCodigo = styled.strong`
  font-variant-numeric: tabular-nums;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.textSecondary};
  width: 32px;
  text-align: right;
  flex-shrink: 0;
`;

export const ItemNome = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
`;

export const ItemNomeLongo = styled.span`
  font-size: 11px;
  color: ${({ theme }) => theme.textSecondary};
  margin-left: 4px;
  flex-shrink: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const EmptyState = styled.div`
  padding: 24px 16px;
  text-align: center;
  color: ${({ theme }) => theme.textSecondary};
  font-size: 13px;
`;
